
import './App.css'
import TestimonialSection from './TestimonialSection'
import Counter from './Counter'
import Tracking from './Tracking'
import Header from './Header'
import HeroSection from './HeroSection'
import { Link } from 'react-router-dom'


function Home() {

  return (
    <>
      <>

        <Header />

        <HeroSection />
        {/* <Tracking/> */}
        {/*/.slider-section*/}
        <section className="about-section padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="about-img-wrap">
                  <img
                    className="wow fade-in-left"
                    data-wow-delay="100ms"
                    src="images/refrence2.jpeg"
                    alt="img"
                  />
                  <img
                    className="wow fade-in-bottom"
                    data-wow-delay="300ms"
                    src="images/refrence.jpeg"
                    alt="img"
                  />
                  <img src="images/delivery-man.png" alt="img" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="section-heading mb-40">
                  <h3 className="sub-heading is-border border-anim">
                    Safe and Reliable Transportation | Your Trusted Trucking Partner
                    <span className="sh-underline">
                      <img className="sh-truck" src="images/truck.svg" alt="truck" />
                    </span>
                  </h3>
                  <h2
                    className="text-anim"
                    data-effect="fade-in-right"
                    data-split="char"
                    data-delay="0.3"
                    data-duration={1}
                  >
                    About <span className="hl">Us!</span>
                  </h2>
                  <p
                    className="text-anim"
                    data-effect="fade-in-bottom"
                    data-ease="power4.out"
                  >
                    Safe and Reliable Transportation began with a single truck,
                    a relentless work ethic, and a vision to redefine what it
                    means to be a trucking partner. Founded by industry veterans
                    who grew tired of empty promises and delayed shipments, we set
                    out to build a company where actions speak louder than words.
                    What started as a modest operation has blossomed into a nationwide
                    leader in freight logistics. But no matter how much we grow, our focus
                    remains unchanged: to treat every shipment as if it’s our own. From the
                    first mile to the last, we prioritize what matters most—your cargo’s
                    safety, your timeline’s integrity, and your peace of mind.
                  </p>
                </div>
                <ul
                  className="check-list mb-20 wow fade-in-bottom"
                  data-wow-delay="100ms"
                >
                  <li>
                    <i className="fa-solid fa-check" />
                    99% Safety Compliance Rating
                  </li>
                  <li>
                    <i className="fa-solid fa-check" />
                    Years of Industry Experience
                  </li>
                  <li>
                    <i className="fa-solid fa-check" />
                    300+ Successful Deliveries Monthly
                  </li>
                </ul>
                <div className="btn-group wow fade-in-bottom" data-wow-delay="300ms">
                  <Link to="/aboutus" className="default-btn">
                    More About Us
                  </Link>
                  <a href='tel:"3017097924"'>  <div className="call-info">
                    <i className="fa-solid fa-phone" />
                    <h3>
                      Have Any Questions?{" "}
                      <span>(301) 709-7924</span>
                    </h3>
                  </div></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*/.about-section*/}
        <section className="service-section bg-grey padding">
          <div className="map-pattern" />
          <div className="container">
            <div className="section-heading text-center mb-40">
              <h3 className="sub-heading is-border border-anim">
                Our Logistics Services!
                <span className="sh-underline">
                  <img className="sh-truck" src="images/truck.svg" alt="truck" />
                </span>
              </h3>
              <h2
                className="text-anim"
                data-effect="fade-in-right"
                data-split="char"
                data-delay="0.3"
                data-duration={1}
              >
                What we are <span className="hl">  offering!</span>
              </h2>
              <p
                className="text-anim"
                data-effect="fade-in-bottom"
                data-ease="power4.out"
              >
                Full truckload (FTL), enclosed trailers, and expedited freight services. Partner with a trucking company <br></br>
                that prioritizes your cargo’s safety and timely delivery.

              </p>
            </div>
            <div className="row gy-lg-0 gy-4">
              <div className="col-lg-4 col-md-6">
                <div
                  className="service-item wow fade-in-bottom"
                  data-wow-delay="100ms"
                >
                  <div className="service-thumb">
                    <img src="images/refrence.jpeg" style={{ height: "230px" }} alt="thumb" />
                  </div>
                  <div className="service-content">
                    <div className="service-icon">
                      <i className="fas fa-road" />{" "}
                      {/* Road icon for dedicated lanes */}
                    </div>
                    <h3>Full Truckload (FTL) Shipping:</h3>
                    <p>
                      Our FTL services ensure your cargo travels alone, reducing handling risks and speeding up delivery.
                    </p>
                    <Link className="read-more" to="/services">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div
                  className="service-item wow fade-in-bottom"
                  data-wow-delay="300ms"
                >
                  <div className="service-thumb">
                    <img src="images/post-3.jpg" style={{ height: "230px", width: "100%" }} alt="thumb" />
                  </div>
                  <div className="service-content">
                    <div className="service-icon">
                      <i className="fas fa-truck" />{" "}
                      {/* Represents shipping/trucks for logistics */}
                    </div>
                    <h3>Expedited Shipping:</h3>
                    <p>
                      Urgent deadlines? Our expedited trucking solutions guarantee fast, direct delivery with priority dispatch.                    </p>
                    <Link className="read-more" to="/services">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div
                  className="service-item wow fade-in-bottom"
                  data-wow-delay="500ms"
                >
                  <div className="service-thumb">
                    <img
                      src="images/refrence3.jpeg"
                      style={{ height: "230px", width: "100%" }}
                      alt="thumb"
                    />
                  </div>
                  <div className="service-content">
                    <div className="service-icon">
                      <i className="fas fa-file-contract" />{" "}
                      {/* Replace with a contract icon */}
                    </div>
                    <h3>Dedicated Fleet Solutions:</h3>
                    <p>
                      Customize delivery schedules and routes with a dedicated trucking team for consistent, reliable service.
                    </p>
                    <Link className="read-more" to="/services">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*/.content-features*/}
        {/* <section class="video-section">
  <div class="video-container">
    <iframe
      class="video-iframe"
      src="https://www.youtube.com/embed/p10x4nxuA-s?autoplay=1&amp;mute=1&amp;loop=1&amp;playlist=p10x4nxuA-s&amp;controls=0&amp;showinfo=0&amp;modestbranding=1&amp;rel=0"
      frameborder="0"
      allow="autoplay; loop; fullscreen"
      allowfullscreen>
    </iframe>
  </div>

  <div class="overlay"></div>

  <div class="content">
    <h1 class="title">Trucking Titans</h1>
    <p class="subtitle">Your freight deserves the best. Let us haul it with style!</p>
    <a href="#" class="btn btn-primary">Join Us</a>
  </div>
</section> */}
        <section className="process-section padding">
          <div className="map-pattern" />
          <div className="container">
            <div className="section-heading text-center mb-40">
              <h3 className="sub-heading is-border border-anim">
                Our Working Process!
                <span className="sh-underline">
                  <img className="sh-truck" src="images/truck.svg" alt="truck" />
                </span>
              </h3>
              <h2
                className="text-anim"
                data-effect="fade-in-right"
                data-split="char"
                data-delay="0.3"
                data-duration={1}
              >
                How We Deliver <br />
                Your <span className="hl">Freight!</span>
              </h2>
              <p
                className="text-anim"
                data-effect="fade-in-bottom"
                data-ease="power4.out"
              >
                Safe & Reliable Transportation delivers freight on time, every time. Nationwide trucking services with a focus <br /> on safety, efficiency, and affordability. Get your load moving today!

              </p>
            </div>
            <div className="row process-wrapper gy-lg-0 gy-4">
              <div className="col-lg-3 col-md-6">
                <div
                  className="process-item wow fade-in-bottom"
                  data-wow-delay="100ms"
                >
                  <div className="process-icon">
                    <i className="logis logis-package" />
                    <span>1</span>
                  </div>
                  <div className="process-content">
                    <h3>Get a quote</h3>
                    <p>
                      Instant, transparent pricing tailored to your shipment’s needs.                      </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div
                  className="process-item wow fade-in-bottom"
                  data-wow-delay="300ms"
                >
                  <div className="process-icon">
                    <i class="fa-solid fa-handshake-simple"></i>
                    <span>2</span>
                  </div>
                  <div className="process-content">
                    <h3>Agreement</h3>
                    <p>
                      Sign a hassle-free contract with flexible terms and no hidden fees.                      </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div
                  className="process-item wow fade-in-bottom"
                  data-wow-delay="500ms"
                >
                  <div className="process-icon">
                    <i className="logis logis-truck-2" />
                    <span>3</span>
                  </div>
                  <div className="process-content">
                    <h3>Pick up</h3>
                    <p>
                      On-time, secure handling by certified professionals at your location.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div
                  className="process-item wow fade-in-bottom"
                  data-wow-delay="700ms"
                >
                  <div className="process-icon">
                    <i className="logis logis-loader" />
                    <span>4</span>
                  </div>
                  <div className="process-content">
                    <h3>Delivery</h3>
                    <p>
                      Real-time tracked, on-schedule arrival—guaranteed seamless from start to finish.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*/.process-section*/}
        <div className="container-fluid truckship mb-3">
          <div className="row">
            <div className="col-md-5"></div>
            <div className="col-lg-6">
              <div className="section-heading white mt-4 pb-3">
                <h3 className="sub-heading is-border border-anim">
                  Trusted Global Shipping!
                  <span className="sh-underline">
                    <img className="sh-truck" src="images/truck.svg" alt="truck" />
                  </span>
                </h3>
                <h2
                  className="text-anim"
                  data-effect="fade-in-right"
                  data-split="char"
                  data-delay="0.3"
                  data-duration={1}
                >
                  Our Trusted Shipping
                  <span className="hl">&nbsp;Partners!</span>
                </h2>
                <p>
                  At Safe and Reliable Transportation, we don’t just move freight—we move businesses forward.
                  Specializing in precision trucking services, our mission is crystal clear: to deliver your
                  cargo safely, securely, and on schedule, every single time. As a trusted leader in the
                  trucking industry, we blend cutting-edge logistics technology with decades of hands-on
                  expertise to create tailored solutions for your unique needs. Our fleet of DOT-certified,
                  meticulously maintained trucks operates like a well-oiled machine, while our seasoned
                  drivers—each rigorously trained in safety protocols and cargo handling—treat your goods
                  with the same care they’d give their own.
                </p>
                <Link
                  to="contact"
                  className="default-btn wow fade-in-bottom"
                  data-wow-delay="200ms"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
        <section className="cta-section mb-3 wow fade-in" data-wow-delay="0.2s">
          <div className="container">
            <div className="row promo-item-wrapper gx-0">
              <div className="col-lg-4 wow fade-in-up" data-wow-delay="0.3s">
                <div className="promo-item">
                  <i className="logis logis-truck-3" />
                  <div className="promo-content">
                    <h3
                      className="text-anim"
                      data-effect="fade-in-right"
                      data-delay="0.3"
                      data-duration={1}
                    >
                      Dedicated Loads
                    </h3>
                    <p className="fade-in-bottom" data-wow-delay="0.5s">
                      We offer reliable trucking services for dedicated lanes and
                      routes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 wow fade-in-up" data-wow-delay="0.4s">
                <div className="promo-item">
                  <i className="logis logis-cruise" />
                  <div className="promo-content">
                    <h3
                      className="text-anim"
                      data-effect="fade-in-right"
                      data-delay="0.3"
                      data-duration={1}
                    >
                      Amazon Loads
                    </h3>
                    <p className="fade-in-bottom" data-wow-delay="0.5s">
                      We specialize in efficient Amazon load handling for on-time
                      deliveries.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 wow fade-in-up" data-wow-delay="0.5s">
                <div className="promo-item">
                  <i className="logis logis-airplane-flying" />
                  <div className="promo-content">
                    <h3
                      className="text-anim"
                      data-effect="fade-in-right"
                      data-delay="0.3"
                      data-duration={1}
                    >
                      Government Contracts
                    </h3>
                    <p className="fade-in-bottom" data-wow-delay="0.5s">
                      As a trusted transporter, secure logistics for government contracts.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*/.cta-section*/}
        {/*/.testimonial-section*/}
        {/*/.sponsor-section*/}
        {/* Review Section */}
        <TestimonialSection />
        {/* Review Section */}
        {/*/.blog-section*/}
        <footer className="footer-section">
          <div className="map-pattern" />
          <div className="footer-wrapper">
            <div className="container">
              <div className="row gy-lg-0 gy-4">
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <Link to="/" className="footer-logo">
                      <img src="images/logo.png" alt="logo" />
                    </Link>
                    <p>
                      Safe and Reliable Transportation specializes in efficient
                      transport warehousing and distribution of goods.
                    </p>
                    <ul className="social-share">
                      <li>
                        <a href="https://www.facebook.com/profile.php?id=61575268596055">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                    
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget widget-links">
                    <div className="widget-title">
                      <h3>Company</h3>
                    </div>
                    <ul className="footer-links">
                      <li>
                        <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                        <Link to="/services">Our Services</Link>
                      </li>
                      <li>
                        <Link to="/testimonials">Testimonials</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/driver">Driver Login</a>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/company">Customer Login</a>
                      </li>
                      <li>
                        <Link to="/resources">Resources</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h3>Get In Touch</h3>
                    </div>
                    <ul className="footer-contact-info">
                      <li>
                        <p>
                          <span>Address:</span>9528 Baltimore, Ave
                          Laurel, MD 20723
                        </p>
                      </li>

                      <li>
                        <p>
                          <span>Call Us:</span>(301) 709-7924
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>Mail Us:</span>humanresource@srtranspor.com
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h3>Newslatter Signup</h3>
                    </div>
                    <form action="#" className="subscribe-form" noValidate="true">
                      <div className="mc-fields">
                        <input
                          className="form-control"
                          type="email"
                          name="EMAIL"
                          placeholder="Your Email"
                          required=""
                        />
                        <input
                          type="hidden"
                          name="action"
                          defaultValue="mailchimpsubscribe"
                        />
                        <button className="submit">
                          <i className="fa-regular fa-arrow-right-long" />
                        </button>
                      </div>
                      <div className="clearfix" />
                      <div id="subscribe-result">
                        <div className="subscription-success" />
                        <div className="subscription-error" />
                      </div>
                    </form>
                    <p className="mt-20">
                      Subscribe us and get all the benifits from today.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="running-truck">
              <div className="truck" />
              <div className="truck-2" />
              <div className="truck-3" />
            </div>
          </div>
          <div className="copyright-area">
            <span id="currentYear"> </span> © Safe and Reliable Transportation ,
            All Rights Reserved.
          </div>
        </footer>
        {/*/.footer-section*/}
        <div id="scrollup">
          <button id="scroll-top" className="scroll-to-top">
            <i className="fa-regular fa-arrow-up" />
          </button>
        </div>
        {/*/.scrollup*/}
        {/*jQuery Lib*/}
        {/* Mirrored from html.dynamiclayers.net/te/logisko/index.html by HTTrack Website Copier/3.x [XR&CO'2014], Thu, 05 Dec 2024 18:01:45 GMT */}
      </>

    </>
  )
}

export default Home
